<template>
  <div class="" id="internjoin">
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto mob-hidden"
    />
    <div
      class="md:py-0 lg:py-0 py-10 flex justify-between md:relative lg:relative"
    >
      <div class="absolute bg-design11 md:block lg:block hidden">
        <img
          src="../../../assets/images/bg-des/JU-donate-bg-t.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design12 md:block lg:block hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="flex flex-wrap sm-fiximg w-full items-center">
        <div class="lg:w-1/2 md:w-1/2 w-full lg:pr-20 md:pr-10">
          <div class="lg:pt-0 md:pt-0 pt-3">
            <p class="title-semibold fsize36-24px">
              Opportunity to learn and develop your skills.
            </p>
            <p class="joinus-subtitle md:pt-10 lg:pt-10 pt-4 fsize24-14px">
              Are you a caregiving professional/attendant who provides
              assistance to people who are unable to take care of themselves due
              to illness, injury or a disability. Register with us and we will
              help you get a suitable job.
            </p>
            <p class="joinus-subtitle md:pt-6 lg:pt-6 pt-3 fsize24-14px">
              Take a step towards more stable career with upskilling and
              learning with us.
            </p>
            <div class="md:pt-10 lg:pt-10 pt-6">
              <!-- <base-button
                type="primary"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 font-semibold border-2 fsize24-14px"
                ><a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/1GcSOidC9cTlBUsS1cxtWrA4Wyzqh1nXLKf_oL2wKtkI/edit"
                  >Care Attendant</a
                ></base-button
              > -->
              <base-button
                type="primary"
                class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 font-semibold border-2 fsize18px"
                @click="
                  handleRoute(
                    'request-form',
                    'partner-with-us-as-care-attendent'
                  )
                "
              >
                <!-- <a
                  target="_blank"
                  class="hover:text-white"
                  @click="handleClick('care-professionals')"
                  > -->
                Care Attendant
                <!-- </a> -->
              </base-button>
            </div>
          </div>
        </div>
        <!-- @click="handleClick('careers')" -->
        <div class="lg:w-1/2 md:w-1/2 w-full h-full flex items-center">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/partnerwithus-care%20attendant.jpg"
            alt=""
            class="mr-auto custborderradius m-auto md:block lg:block"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      // this.toggleNavbar();
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
